module.exports = __webpack_public_path__ + "img/banner.d74c310.png";